import moment from "moment-timezone";
import axios from "axios";
import { authHeader, accessToken } from "./auth-header";
import jwtInterceptor  from "./jwt-interceptor"
import { Capacitor, Filesystem, FilesystemDirectory, FilesystemEncoding } from "@capacitor/core";
import { Browser } from '@capacitor/browser';
import { RH_URL, router} from "./";
//import mime, { contentType } from 'mime-types';


export const isProduction = process.env.NODE_ENV === "production";
export const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};
/*
const PRESERVE = {
  "file-type":"a",
  "original-url":"a",
  "attachment-file-name":"a",
  "background":"a",
  "medium-url":"a",
  "formatted-total":"a",
  "account-rally-id":"a",
  "sku-id":"a",
  "creator-id":"a",
  "creator-first-name":"a",
  "created-at":"a",
  "creator-avatar":"a",
  "creator-last-name":"a",
  "file-size":"a",
  "small-url":"a",
  "contact-phone":"a",
  "contact-email":"a",
  "image-url":"a",
  "from-date":"a",
  "amount":"a",
  "max-participants":"a",
  "converted-start":"a",
  "user-id":"a",
  "first-name":"a",
  "last-name":"a",
  "participant-type":"a",
  "updated-at":"a",
  "role":"a",
  "current-position":"a",
  "phone":"a",
  "formatted-taxes":"a",
  "formatted-fees":"a",
  "child-count":"a",
  "member-count":"a",
  "type":"a",
  "lifecycle":"a",
  "title":"a",
  "body":"a",
  "content_type":"a",
  "right-rally-id":"a",
  "rally-id":"a",
  "cost":"a",
  "description":"a",
  "total":"a",
  "goal":"a",
  "url":"a",
  "quantity":"a",
  "email":"a",
  "status":"a",
  "avatar":"a",
  "privacy":"a",
  "editable":"a"  
};
export function cleanObjects(objs) {
  return objs
  //clean attributes that aren't needed!
  if (objs && objs.length > 0) {
    objs.forEach(obj => {
      if (obj.attributes) {
        Object.keys(obj.attributes).forEach(k => {
          if (!PRESERVE[k]) {
            obj.attributes[k] = null;
          }
        });
      }
    });
  }
}*/

export function isMobile(){
  const platform = Capacitor.getPlatform();
  //const isWeb = platform === 'web';
  console.log("navigator.userAgent")
  console.log(navigator.userAgent)
  console.log(navigator.maxTouchPoints)
  const ismob = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints  && navigator.maxTouchPoints > 1);
  return ismob
}

export async function downloadFile(fileUrl, fileName) {
  try {
    let contentType = ""//mime.lookup(fileName)  
    contentType = contentType ? contentType : 'application/octet-stream'
    const response = await fetch(fileUrl, {
     method: 'GET',
     headers: {
       'Content-Type': contentType,
       "cache-control": "max-age=0",
       "referrerPolicy": "strict-origin-when-cross-origin"
     }
   });
   if (!response.ok) {
     throw new Error('Network response was not ok');
   }
   const blob = await response.blob();
   let result = null
   if (Capacitor.getPlatform() != 'web') {
      Browser.open({ url: fileUrl });
   } else {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
 } catch (error) {
   console.error('There was an error downloading the file:', error);
 }

}


export function getCapOpenParam(){
   return Capacitor.getPlatform() == "web" ?  "2" : "1"
}
export function openRhWebBrowserCreate(rId, returnTo){
  const url = RH_URL();
  const rallyId = rId;
  const mt = accessToken();
  const capOpenParam = "&cap_open=" + getCapOpenParam()
  //console.log("url " + `${url}?mt=${mt}` +  capOpenParam)
  //Browser.open({ url: `${url}?mt=${mt}` +  capOpenParam });
  console.log("url " + `${url}?mt=${mt}&return_to=/${rallyId}/${returnTo}` + capOpenParam)
  Browser.open({ url: `${url}?mt=${mt}&return_to=/${rallyId}/${returnTo}`+ capOpenParam });
  Browser.addListener('browserFinished', () => {
      console.log('browserFinished event called')
      router.push(`/${rallyId}`)
      location.reload()
  });
}

export function openRhWebBrowser(id, rId, mode){
  const url = RH_URL();
  const rallyId = rId
  const mt = accessToken();
  const cid = id 
  const theMode = mode  == "edit" ? "edit?cap_open=" + getCapOpenParam() : "payments?cap_open=" + getCapOpenParam()
  //window.open(`${url}?mt=${mt}&return_to=/${rallyId}/fundraisers/${cid}/${theMode}`);
  console.log("url is...."  + `${url}?mt=${mt}&return_to=/${rallyId}/fundraisers/${cid}/${theMode}`)
  Browser.open({ url: `${url}?mt=${mt}&return_to=/${rallyId}/fundraisers/${cid}/${theMode}` });
  Browser.addListener('browserFinished', () => {
    console.log('browserFinished event called')
    router.push(`/${rallyId}`)
    location.reload()
  });
}
export function isValidBase64(str) {
    const base64Regex = /^(?:[A-Za-z0-9+/]{4}\n?)*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    return base64Regex.test(str);
}

export function findDefaultChannelOfTypeForRally(
  typeName,
  chanByRallyIdMap,
  rallyId
) {
  var chanList = chanByRallyIdMap[rallyId];
  if (chanList) {
    return findDefaultChannelOfType(typeName, chanList);
  } else {
    return null;
  }
}
export function findDefaultChannelOfType(typeName, chanList) {
  for (var c of chanList) {
    if (typeName == c.attributes.type && c.attributes.default) {
      return c.id;
    }
  }
  return null;
}

export function findDefaultChannelObjOfTypeForRally(
  typeName,
  chanByRallyIdMap,
  rallyId
) {
  var chanList = chanByRallyIdMap[rallyId];
  if (chanList) {
    return findDefaultChannelObjOfType(typeName, chanList);
  } else {
    return null;
  }
}
export function findDefaultChannelObjOfType(typeName, chanList, subTypeName = '') {
  for (var c of chanList) {
      if (typeName == 'Event' && c.attributes.type == 'Calendar') {
          return c;
      } else if (typeName == 'Fundraiser' && c.attributes.type == 'Payables') {
          return c;
      } else if (typeName == 'Container' && subTypeName == 'SignupList' && c.attributes.type == 'Signups') {
            return c;
      } else if (typeName == 'Container' && subTypeName == 'Board' && c.attributes.type == 'Links') {
          return c;
      } else if (typeName == 'Container' && subTypeName == 'Album' && c.attributes.type == 'Gallery') {
            return c;
      } else if (typeName == 'SignupList' && c.attributes.type == 'Signups') {
            return c;
      }
      else {
          if (typeName == c.attributes.type && c.attributes.default) {
              return c;
          }
      }
  }
  return null;
}

export function fixFilename(name) {
  return name?.replace(/[\s\-–—]+/g, '')
}

export function kebabCase(string) {
  let kebab = string
    .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2")
    .toLowerCase();
  kebab = kebab.replace("_", "-");
  if (kebab[0] == "-") {
    kebab = kebab.substring(1);
  }
  return kebab;
}

/**
 * Pass an array of attribute names...if proceeded with a minus sign then reverse sort
 *
 **/
export const compareBy = (sortOverrideMap = {}, ...props) => (a, b) => {
  for (let i = 0; i < props.length; i++) {
    const ascValue = props[i].startsWith("-") ? -1 : 1;
    const prop = props[i].startsWith("-") ? props[i].substr(1) : props[i];
    if (a.attributes[prop] !== b.attributes[prop]) {
      var aVal = a.attributes[prop];
      aVal = sortOverrideMap[aVal] ? sortOverrideMap[aVal] : aVal;
      var bVal = b.attributes[prop];
      bVal = sortOverrideMap[bVal] ? sortOverrideMap[bVal] : bVal;
      return aVal > bVal ? ascValue : -ascValue;
    }
  }
  return 0;
};

export function sortParamsForContentType(contentType, contextType){
  let s =  "content_type desc,title"
  if (contentType == "Message" || contentType == "File" || contentType == "Fundraiser"){
    s =   "content_type,shares.sort_order,shares.start_date desc,shares.created_at desc" 
  } else if (contentType?.indexOf("Event") >= 0) {
    s =  "converted_start desc" 
    if (contextType == "Channel"){
      s =  "converted_start desc,title" 
    }
   
  }
  console.log(contextType + "@@@" + contentType + ":::::" +s)
  return s 
}

export function pageSizeForChannelType(channelType){
  if (["Signups"].includes(channelType)) {
    return 100
  } else if (["Files", "Links", "Gallery", "Payables"].includes(channelType)) {
    return  15
  } else {
    return 30
  }
}


export function sortByDate(arr, childName, dateName) {
  if (!arr) {
    return [];
  } else {
    return arr.sort(function(a, b) {
      try {
        if (a[childName][dateName] > b[childName][dateName]) {
          return -1;
        } else if (a[childName][dateName] < b[childName][dateName]) {
          return 1;
        } else {
          return 0;
        }
      } catch (e) {
        //not sure how to get the logger working in utils yet
        console.log(e);
        return 0;
      }
    });
  }
}

export function sortByDateOlderFirst(arr, childName, dateName) {
  if (!arr) {
    return [];
  } else {
    return arr.sort(function(a, b) {
      try {
        if (a[childName][dateName] > b[childName][dateName]) {
          return 1;
        } else if (a[childName][dateName] < b[childName][dateName]) {
          return -1;
        } else {
          return 0;
        }
      } catch (e) {
        //not sure how to get the logger working in utils yet
        console.log(e);
        return 0;
      }
    });
  }
}




export function typeToVueSlugMap() {
  return {
    Directory: "directory",
    MessageWall: "messages",
    Signups: "signups",
    Files: "files",
    Links: "links",
    GivePayableGroup: "give",
    Payables: "special_events",
    Gallery: "media",
    Calendar: "events",
    PayableGroup: "pay",
    Members: "members",
    Rallies: "explore"
  };
}

export function slugToTypeObjectMap() {
  return {
    childRallies: {
      newAction: "",
      type: "childRallies",
      componentName: "",
      contentType: "",
      channelType: "",
      channelTypePlural: "childRallies" 
    },
      explore: {
          newAction: "",
          type: "childRallies",
          componentName: "",
          contentType: "",
          channelType: "",
          channelTypePlural: "childRallies"
      },
    messages: {
      newAction: "createMessage",
      type: "WallMessage",
      componentName: "Message",
      contentType: "Message",
      channelType: "MessageWall",
      channelTypePlural: "MessageWall",
      badgeCountName: "Message:WallMessage"
    },
    events: {
      newAction: "createMessage",
      type: "Event",
      componentName: "Event",
      contentType: "Event",
      channelType: "Event",
      channelTypePlural: "Events",
      altChannelTypePlural: "Calendar",
      badgeCountName: "Event:CalendarEvent"
    },
    special_events: {
      newAction: "createMessage",
      type: "PayableEvent",
      componentName: "PayableEvent",
      contentType: "Fundraiser",
      channelType: "Payables",
      channelTypePlural: "Payables",
      altChannelTypePlural: "Payables",
      badgeCountName: "Fundraiser:PayableEvent"

    },
    files: {
      newAction: "createMessage",
      type: ["File", "Folder", "Attachment"],
      componentName: "File",
      contentType: ["Attachment", "Binary", "Container"],
      channelType: "File",
      channelTypePlural: "Files",
      badgeCountName: "Binary:File"
    },
    links: {
      newAction: "createMessage",
      type: ["Board", "Link"],
      componentName: "Link",
      contentType: ["Link", "Container"],
      channelType: "Link",
      channelTypePlural: "Links",
      badgeCountName: "Link:Link"
    },
    media: {
      newAction: "addPhoto",
      type: ["Album", "Photo", "Attachment"],
      componentName: "Gallery",
      contentType: ["Attachment", "Binary", "Container"],
      channelType: "Gallery",
      channelTypePlural: "Gallery",
      badgeCountName: "Binary:Photo"
    },
    give: {
      newAction: "createMessage",
      type: "GivePayableGroup",
      componentName: "GivePayableGroup",
      contentType: "Container",
      channelType: "GivePayableGroup",
      channelTypePlural: "GivePayableGroup",
      badgeCountName: "Container:GivePayableGroup"
    },
    pay: {
      newAction: "createMessage",
      type: "PayableGroup",
      contentType: "Container",
      componentName: "PayableGroup",
      channelType: "PayableGroup",
      channelTypePlural: "PayableGroup",
      badgeCountName: "Container:PayableGroup"
    },
    signups: {
      newAction: "createMessage",
      type: "SignupList",
      componentName: "Signup",
      contentType: ["SignupEvent", "Container"],
      channelType: "Signups",
      channelTypePlural: "Signups",
      badgeCountName: "Event:SignupEvent"
    },
    directory: {
      newAction: "createMessage",
      type: "Signups",
      componentName: "Signup",
      contentType: "",
      channelType: "Signups",
      channelTypePlural: "Signups"
    }
  };
}

export function channelTypeObjectMap() {
    return {
        Rallies: {
            newAction: "",
            type: "childRallies",
            componentName: "",
            contentType: "",
            channelType: "",
            channelTypePlural: "childRallies"
        },
        MessageWall: {
            newAction: "createMessage",
            type: "WallMessage",
            componentName: "Message",
            contentType: "Message",
            channelType: "MessageWall",
            channelTypePlural: "MessageWall",
            badgeCountName: "Message:WallMessage"
        },
        Calendar: {
            newAction: "createMessage",
            type: "Event",
            componentName: "Event",
            contentType: "Event",
            channelType: "Event",
            channelTypePlural: "Events",
            altChannelTypePlural: "Calendar",
            badgeCountName: "Event:CalendarEvent"
        },
        Fundraiser: {
            newAction: "createMessage",
            type: "PayableEvent",
            componentName: "PayableEvent",
            contentType: "Fundraiser",
            channelType: "Payables",
            channelTypePlural: "Payables",
            altChannelTypePlural: "Payables",
            badgeCountName: "Fundraiser:PayableEvent"

        },
        Payables: {
            newAction: "createMessage",
            type: "PayableEvent",
            componentName: "PayableEvent",
            contentType: "Fundraiser",
            channelType: "Payables",
            channelTypePlural: "Payables",
            altChannelTypePlural: "Payables",
            badgeCountName: "Fundraiser:PayableEvent"

        },
        Files: {
            newAction: "createMessage",
            type: ["File", "Folder", "Attachment"],
            componentName: "File",
            contentType: ["Attachment", "Binary", "Container"],
            channelType: "File",
            channelTypePlural: "Files",
            badgeCountName: "Binary:File"
        },
        Links: {
            newAction: "createMessage",
            type: ["Board", "Link"],
            componentName: "Link",
            contentType: ["Link", "Container"],
            channelType: "Link",
            channelTypePlural: "Links",
            badgeCountName: "Link:Link"
        },
        Gallery: {
            newAction: "addPhoto",
            type: ["Album", "Photo", "Attachment"],
            componentName: "Gallery",
            contentType: ["Attachment", "Binary", "Container"],
            channelType: "Gallery",
            channelTypePlural: "Gallery",
            badgeCountName: "Binary:Photo"
        },
        GivePayableGroup: {
            newAction: "createMessage",
            type: "GivePayableGroup",
            componentName: "GivePayableGroup",
            contentType: "Container",
            channelType: "GivePayableGroup",
            channelTypePlural: "GivePayableGroup",
            badgeCountName: "Container:GivePayableGroup"
        },
        PayableGroup: {
            newAction: "createMessage",
            type: "PayableGroup",
            contentType: "Container",
            componentName: "PayableGroup",
            channelType: "PayableGroup",
            channelTypePlural: "PayableGroup",
            badgeCountName: "Container:PayableGroup"
        },
        Signups: {
            newAction: "createMessage",
            type: "SignupList",
            componentName: "Signup",
            contentType: ["Event", "Container"],
            channelType: "Signups",
            channelTypePlural: "Signups",
            badgeCountName: "Event:SignupEvent"
        },
        Directory: {
            newAction: "createMessage",
            type: "Signups",
            componentName: "Signup",
            contentType: "",
            channelType: "Signups",
            channelTypePlural: "Signups"
        }
    };
}

export function railsTzToMomentTz(k) {
  return RAILS_TZ_TO_MOMENT_TZ[k]
}

export const RAILS_TZ_TO_MOMENT_TZ = {
  "Adelaide"	:	      "Australia/Adelaide"             	,
  "Alaska"	:	      "America/Anchorage"              	,
  "Almaty"	:	      "Asia/Almaty"                    	,
  "Amsterdam"	:	      "Europe/Amsterdam"               	,
  "Arizona"	:	      "America/Phoenix"               	,
  "Athens"	:	      "Europe/Athens"                  	,
  "Atlantic Time (Canada)"	:	      "America/Anguilla"               	,
  "Auckland"	:	      "Pacific/Auckland"               	,
  "Azores"	:	      "Atlantic/Azores"                	,
  "Baghdad"	:	      "Asia/Baghdad"                   	,
  "Baku"	:	      "Asia/Baku"                      	,
  "Bangkok"	:	      "Asia/Bangkok"                   	,
  "Belgrade"	:	      "Europe/Belgrade"                	,
  "Berlin"	:	      "Europe/Berlin"                  	,
  "Bogota"	:	      "America/Bogota"                 	,
  "Bratislava"	:	      "Europe/Bratislava"              	,
  "Brisbane"	:	      "Australia/Brisbane"             	,
  "Brussels"	:	      "Europe/Brussels"                	,
  "Bucharest"	:	      "Europe/Bucharest"               	,
  "Budapest"	:	      "Europe/Budapest"                	,
  "Buenos Aires"	:	      "America/Argentina/Buenos_Aires" 	,
  "Cairo"	:	      "Africa/Cairo"                   	,
  "Cape Verde Is."	:	      "Atlantic/Cape_Verde"            	,
  "Caracas"	:	      "America/Caracas"                	,
  "Casablanca"	:	      "Africa/Casablanca"              	,
  "Central Time (US & Canada)"	:	      "America/Chicago"                	,
  "Chihuahua"	:	      "America/Chihuahua"              	,
  "Chongqing"	:	      "Asia/Chongqing"                 	,
  "Copenhagen"	:	      "Europe/Copenhagen"              	,
  "Darwin"	:	      "Australia/Darwin"               	,
  "Dhaka"	:	      "Asia/Dhaka"                     	,
  "Dublin"	:	      "Europe/Dublin"                  	,
  "Eastern Time (US & Canada)"	:	      "America/Detroit"                	,
  "Fiji"	:	      "Pacific/Fiji"                   	,
  "Guam"	:	      "Pacific/Guam"                   	,
  "Hawaii"	:	      "Pacific/Honolulu"               	,
  "Helsinki"	:	      "Europe/Helsinki"                	,
  "Hobart"	:	      "Australia/Hobart"               	,
  "Hong Kong"	:	      "Asia/Hong_Kong"                 	,
  "Irkutsk"	:	      "Asia/Irkutsk"                   	,
  "Istanbul"	:	      "Europe/Istanbul"                	,
  "Jakarta"	:	      "Asia/Jakarta"                   	,
  "Jerusalem"	:	      "Asia/Jerusalem"                 	,
  "Kabul"	:	      "Asia/Kabul"                     	,
  "Kamchatka"	:	      "Asia/Kamchatka"                 	,
  "Karachi"	:	      "Indian/Maldives"                	,
  "Kathmandu"	:	      "Asia/Kathmandu"                 	,
  "Kolkata"	:	      "Asia/Kolkata"                   	,
  "Krasnoyarsk"	:	      "Asia/Krasnoyarsk"               	,
  "Kuala Lumpur"	:	      "Asia/Kuala_Lumpur"              	,
  "Kuwait"	:	      "Asia/Kuwait"                    	,
  "La Paz"	:	      "America/La_Paz"                 	,
  "Lima"	:	      "America/Lima"                   	,
  "Lisbon"	:	      "Europe/Lisbon"                  	,
  "Ljubljana"	:	      "Europe/Ljubljana"               	,
  "London"	:	      "Europe/London"                  	,
  "Madrid"	:	      "Europe/Madrid"                  	,
  "Magadan"	:	      "Asia/Magadan"                   	,
  "Mazatlan"	:	      "America/Mazatlan"               	,
  "Melbourne"	:	      "Australia/Melbourne"            	,
  "Mexico City"	:	      "America/Mexico_City"            	,
  "Mid-Atlantic"	:	      "Atlantic/South_Georgia"         	,
  "Minsk"	:	      "Europe/Minsk"                   	,
  "Monrovia"	:	      "Africa/Monrovia"                	,
  "Monterrey"	:	      "America/Monterrey"              	,
  "Moscow"	:	      "Europe/Moscow"                  	,
  "Mountain Time (US & Canada)"	:	      "America/Denver",  
  "Mountain Standard Time (US & Canada)"	:	      "America/Phoenix"                	,
  "Mumbai"	:	      "Asia/Colombo"                   	,
  "Muscat"	:	      "Asia/Muscat"                    	,
  "Nairobi"	:	      "Africa/Nairobi"                 	,
  "Newfoundland"	:	      "America/St_Johns"               	,
  "Novosibirsk"	:	      "Asia/Novosibirsk"               	,
  "Nuku'alofa"	:	      "Pacific/Enderbury"              	,
  "Pacific Time (US & Canada)"	:	      "America/Los_Angeles"            	,
  "Paris"	:	      "Europe/Paris"                   	,
  "Perth"	:	      "Australia/Perth"                	,
  "Port Moresby"	:	      "Pacific/Port_Moresby"           	,
  "Prague"	:	      "Europe/Prague"                  	,
  "Rangoon"	:	      "Asia/Rangoon"                   	,
  "Riga"	:	      "Europe/Riga"                    	,
  "Riyadh"	:	      "Asia/Riyadh"                    	,
  "Rome"	:	      "Europe/Rome"                    	,
  "Samoa"	:	      "Pacific/Pago_Pago"              	,
  "Santiago"	:	      "America/Santiago"               	,
  "Sarajevo"	:	      "Europe/Sarajevo"                	,
  "Seoul"	:	      "Asia/Seoul"                     	,
  "Singapore"	:	      "Asia/Singapore"                 	,
  "Skopje"	:	      "Europe/Skopje"                  	,
  "Sofia"	:	      "Europe/Sofia"                   	,
  "Solomon Is."	:	      "Asia/Anadyr"                    	,
  "Stockholm"	:	      "Europe/Stockholm"               	,
  "Sydney"	:	      "Australia/Sydney"               	,
  "Taipei"	:	      "Asia/Taipei"                    	,
  "Tallinn"	:	      "Europe/Tallinn"                 	,
  "Tashkent"	:	      "Asia/Tashkent"                  	,
  "Tbilisi"	:	      "Asia/Tbilisi"                   	,
  "Tehran"	:	      "Asia/Tehran"                    	,
  "Tijuana"	:	      "America/Tijuana"                	,
  "Tokyo"	:	      "Asia/Tokyo"                     	,
  "Urumqi"	:	      "Asia/Urumqi"                    	,
  "Vienna"	:	      "Europe/Vienna"                  	,
  "Vilnius"	:	      "Europe/Vilnius"                 	,
  "Vladivostok"	:	      "Asia/Vladivostok"               	,
  "Volgograd"	:	      "Europe/Volgograd"               	,
  "Warsaw"	:	      "Europe/Warsaw"                  	,
  "Yakutsk"	:	      "Asia/Yakutsk"                   	,
  "Yerevan"	:	      "Asia/Yerevan"                   	,
  "Zagreb"	:	      "Europe/Zagreb"                  	
}

const MOMENT_TZ_TO_RAILS_TZ = Object.fromEntries(
    Object.entries(RAILS_TZ_TO_MOMENT_TZ).map(([railsTz, momentTz]) => [momentTz, railsTz])
);

// Function to convert Moment.js timezone to Rails timezone
export function momentTzToRailsTz(k) {
    return MOMENT_TZ_TO_RAILS_TZ[k];
}

export const TIMEZONE_MAPPING = {
  "Adelaide"	:	 "Adelaide"	,
 "Alaska"	:	 "Alaska"	,
 "Almaty"	:	 "Almaty"	,
 "Amsterdam"	:	 "Amsterdam"	,
 "Arizona"	:	   "Arizona"               	,
 "Athens"	:	 "Athens"	,
 "Atlantic Time (Canada)"	:	 "Atlantic Time (Canada)"	,
 "Auckland"	:	 "Auckland"	,
 "Azores"	:	 "Azores"	,
 "Baghdad"	:	 "Baghdad"	,
 "Baku"	:	 "Baku"	,
 "Bangkok"	:	 "Bangkok"	,
 "Belgrade"	:	 "Belgrade"	,
 "Berlin"	:	 "Berlin"	,
 "Bogota"	:	 "Bogota"	,
 "Bratislava"	:	 "Bratislava"	,
 "Brisbane"	:	 "Brisbane"	,
 "Brussels"	:	 "Brussels"	,
 "Bucharest"	:	 "Bucharest"	,
 "Budapest"	:	 "Budapest"	,
 "Buenos Aires"	:	 "Buenos Aires"	,
 "Cairo"	:	 "Cairo"	,
 "Cape Verde Is."	:	 "Cape Verde Is."	,
 "Caracas"	:	 "Caracas"	,
 "Casablanca"	:	 "Casablanca"	,
 "Central Time (US & Canada)"	:	 "Central Time (US & Canada)"	,
 "Chihuahua"	:	 "Chihuahua"	,
 "Chongqing"	:	 "Chongqing"	,
 "Copenhagen"	:	 "Copenhagen"	,
 "Darwin"	:	 "Darwin"	,
 "Dhaka"	:	 "Dhaka"	,
 "Dublin"	:	 "Dublin"	,
 "Eastern Time (US & Canada)"	:	 "Eastern Time (US & Canada)"	,
 "Fiji"	:	 "Fiji"	,
 "Guam"	:	 "Guam"	,
 "Harare"	:	 "Harare"	,
 "Hawaii"	:	 "Hawaii"	,
 "Helsinki"	:	 "Helsinki"	,
 "Hobart"	:	 "Hobart"	,
 "Hong Kong"	:	 "Hong Kong"	,
 "Irkutsk"	:	 "Irkutsk"	,
 "Istanbul"	:	 "Istanbul"	,
 "Jakarta"	:	 "Jakarta"	,
 "Jerusalem"	:	 "Jerusalem"	,
 "Kabul"	:	 "Kabul"	,
 "Kamchatka"	:	 "Kamchatka"	,
 "Karachi"	:	 "Karachi"	,
 "Kathmandu"	:	 "Kathmandu"	,
 "Kolkata"	:	 "Kolkata"	,
 "Krasnoyarsk"	:	 "Krasnoyarsk"	,
 "Kuala Lumpur"	:	 "Kuala Lumpur"	,
 "Kuwait"	:	 "Kuwait"	,
 "La Paz"	:	 "La Paz"	,
 "Lima"	:	 "Lima"	,
 "Lisbon"	:	 "Lisbon"	,
 "Ljubljana"	:	 "Ljubljana"	,
 "London"	:	 "London"	,
 "Madrid"	:	 "Madrid"	,
 "Magadan"	:	 "Magadan"	,
 "Mazatlan"	:	 "Mazatlan"	,
 "Melbourne"	:	 "Melbourne"	,
 "Mexico City"	:	 "Mexico City"	,
 "Mid-Atlantic"	:	 "Mid-Atlantic"	,
 "Minsk"	:	 "Minsk"	,
 "Monrovia"	:	 "Monrovia"	,
 "Monterrey"	:	 "Monterrey"	,
 "Moscow"	:	 "Moscow"	,
 "Mountain Time (US & Canada)"	:	 "Mountain Time (US & Canada)"	,
 "Mumbai"	:	 "Mumbai"	,
 "Muscat"	:	 "Muscat"	,
 "Nairobi"	:	 "Nairobi"	,
 "Newfoundland"	:	 "Newfoundland"	,
 "Novosibirsk"	:	 "Novosibirsk"	,
 "Nuku'alofa"	:	 "Nuku'alofa"	,
 "Pacific Time (US & Canada)"	:	 "Pacific Time (US & Canada)"	,
 "Paris"	:	 "Paris"	,
 "Perth"	:	 "Perth"	,
 "Port Moresby"	:	 "Port Moresby"	,
 "Prague"	:	 "Prague"	,
 "Rangoon"	:	 "Rangoon"	,
 "Riga"	:	 "Riga"	,
 "Riyadh"	:	 "Riyadh"	,
 "Rome"	:	 "Rome"	,
 "Samoa"	:	 "Samoa"	,
 "Santiago"	:	 "Santiago"	,
 "Sarajevo"	:	 "Sarajevo"	,
 "Seoul"	:	 "Seoul"	,
 "Singapore"	:	 "Singapore"	,
 "Skopje"	:	 "Skopje"	,
 "Sofia"	:	 "Sofia"	,
 "Solomon Is."	:	 "Solomon Is."	,
 "Stockholm"	:	 "Stockholm"	,
 "Sydney"	:	 "Sydney"	,
 "Taipei"	:	 "Taipei"	,
 "Tallinn"	:	 "Tallinn"	,
 "Tashkent"	:	 "Tashkent"	,
 "Tbilisi"	:	 "Tbilisi"	,
 "Tehran"	:	 "Tehran"	,
 "Tijuana"	:	 "Tijuana"	,
 "Tokyo"	:	 "Tokyo"	,
 "Urumqi"	:	 "Urumqi"	,
 "Vienna"	:	 "Vienna"	,
 "Vilnius"	:	 "Vilnius"	,
 "Vladivostok"	:	 "Vladivostok"	,
 "Volgograd"	:	 "Volgograd"	,
 "Warsaw"	:	 "Warsaw"	,
 "Yakutsk"	:	 "Yakutsk"	,
 "Yerevan"	:	 "Yerevan"	,
 "Zagreb"	:	 "Zagreb"	
}


export function generateCustomFieldJSON(customFields, customFieldValues){
  if (customFields && customFields.length > 0){
      let cfields = {custom_fields:[]}
      for (let i = 0; i < customFields.length; i++) {
        let cfname = customFields[i].name;
        let cfvalue = customFieldValues && customFieldValues.length >= i+ 1 ? customFieldValues[i] : ""
        cfields.custom_fields.push({name: cfname, value: cfvalue})
      }
      return JSON.stringify(cfields)
  } else {
    return null 
  }
}

export function slugToContentTypeMap() {
  return {
    special_events: ["Fundraiser"],
    files: ["Binary", "Link", "Container"]
  };
}

export function clearContentIdFromMapOfLists(m, id) {
  var keys = Object.keys(m);
  var nm = {};
  keys.forEach(k => {
    var l = m[k];
    var fl = l.filter(function(item) {
      return item.id !== id;
    });
    nm[k] = fl;
  });
  return nm;
}
export function getChannelIdsByType(typeName, channelMap) {
  var arrayOfArrays = Object.values(channelMap);
  var channelIds = [];
  arrayOfArrays.forEach(alist => {
    var defChan = findDefaultChannelOfType(typeName, alist);
    if (defChan) {
      channelIds.push(defChan);
    }
  });
  return channelIds;
}

export function buildMapByValueName(valueName, list) {
  var map = new Map();
  if (list && list.length > 0) {
    list.forEach(obj => {
      map[obj[valueName] + ""] = obj;
    });
  }
  return map;
}

export function buildMapOfListsByValueName(list, valueName, map = new Map()) {
  if (list && list.length > 0) {
    list.forEach(obj => {
      var maplist = map[obj[valueName]];
      if (!maplist) {
        maplist = [];
      }
      maplist.push(obj);
      map[obj[valueName]] = maplist;
    });
  }
  return map;
}

export function buildMapOfListsByAttribute(list, attributeName) {
  var map = new Map();
  if (list && list.length > 0) {
    list.forEach(obj => {
      var maplist = map[obj.attributes[attributeName]];
      if (!maplist) {
        maplist = [];
      }
      maplist.push(obj);
      map[obj.attributes[attributeName]] = maplist;
    });
  }
  return map;
}

export function figureOutPageNumber(pnums){
  var pageNumber = 1
  //var pnums = state.membersMaxPageByRally[rallyId]
  if (pnums){
    for (var i = 1; i < 25; i++){
      //find the first page number that hasn't been called yet...this prevents a bug where infinite scroll was skipping page nums
      if (!pnums[i]){
        pageNumber = i
        //console.log("npn " + pageNumber)
        break
      }
    }
  }
  return pageNumber
}

export function enrichDataWithIncluded(response) {
    const { data, included } = response.data;

    // Step 1: Create a map of included objects by id and type
    const includedMap = included.reduce((map, item) => {
        const key = `${item.type}:${item.id}`;
        map[key] = {
            id: item.id,
            attributes: item.attributes,
            type: item.type,
        };
        return map;
    }, {});


    // Step 2: Enrich each data element with its related included objects
    const enrichedData = data.map((item) => {
        const relationships = item.relationships || {};
        // Add related included data to attributes
        const enrichedAttributes = { ...item.attributes };
        for (const [key, relation] of Object.entries(relationships)) {
            if (relation.data) {
                if (Array.isArray(relation.data)) {
                    // Handle relationships with multiple related items
                    enrichedAttributes[key] = relation.data.map((rel) => includedMap[`${rel.type}:${rel.id}`]);
                } else {
                    // Handle single related item
                    const relKey = `${relation.data.type}:${relation.data.id}`;
                    enrichedAttributes[key] = includedMap[relKey];
                }
            }
        }

        // Return the enriched object
        return {
            id: item.id,
            type: item.type,
            attributes: enrichedAttributes,
        };
    });

    return enrichedData;
}


export function mergeById(list1, list2, idName) {
  var map = new Map();
  if (list1 && list1.length > 0) {
    list1.forEach(obj => {
      map.set(obj[idName], obj);
    });
  }
  if (list2 && list2.length > 0) {
    list2.forEach(obj => {
      map.set(obj[idName], obj);
    });
  }
  return Array.from(map.values());
}

export function mergeByAtt(list1, list2, attName) {
  var map = new Map();
  if (list1 && list1.length > 0) {
    list1.forEach(obj => {
      map.set(obj.attributes[attName], obj);
    });
  }
  if (list2 && list2.length > 0) {
    list2.forEach(obj => {
      map.set(obj.attributes[attName], obj);
    });
  }
  return Array.from(map.values());
}

export function mergeByIdMaintainOrder(list1, list2, idName) {
  var map2 = new Map();
  var combinedMap = new Map();
  var newList = [];
  if (list2 && list2.length > 0) {
    list2.forEach(obj => {
      var id = obj[idName];
      map2.set(id, obj);
    });
  }
  list1.forEach(obj => {
    var id = obj[idName];
    if (!combinedMap.get(id)) {
      if (map2.get(id)) {
        newList.push(map2.get(id));
      } else {
        newList.push(obj);
      }
      combinedMap.set(id, obj);
    }
  });
  if (list2 && list2.forEach) {
      list2.forEach(obj => {
        var id = obj[idName];
        if (!combinedMap.get(id)) {
          newList.push(obj);
        }
      });
  }
  return newList;
}

export function buildServiceParamMap(json) {
  var params = new URLSearchParams();
  Object.keys(json).forEach(key => {
    if (json[key]) {
      if (Array.isArray(json[key])) {
        for (var x of json[key]) {
          params.append(key + "[]", x);
        }
      } else {
        params.append(key, json[key]);
      }
    }
  });
  return params;
}

export async function performGet(jsonParams, url, user) {
  var params = buildServiceParamMap(jsonParams);
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: authHeader()
    },
    url: url,
    params: params
  };
  const response = await jwtInterceptor(requestOptions);
  return response;
}

export function buildListOfAttributeValues(attName, sourceObjList) {
  var newList = [];
  sourceObjList.forEach(obj => {
    newList.push(obj.attributes[attName]);
  });
  return newList;
}

export function buildListOfValues(attName, sourceObjList) {
  var newList = [];
  sourceObjList.forEach(obj => {
    newList.push(obj[attName]);
  });
  return newList;
}

//needed for infinite scroll...have to append to lists in a map keyed by id as scrolling happens
//only used by member sort right now
export function updateMapById(
  state,
  masterMapName,
  keyFieldName,
  key,
  list,
  sortParams,
  sortOverrideMap = {}
) {
  var changed = null;
  if (list && list.length > 0) {
    var curarr = state[masterMapName][key];
    if (!curarr) {
      curarr = [];
    }
    var prevsize = curarr.length;
    //need to preserve the return order
    var newarr = mergeById(curarr, list, keyFieldName) //[...curarr, ...list]
    var byIdObj = {};
    //no longer sorting in memory
    byIdObj[key] = newarr//.sort(compareBy(sortOverrideMap, ...sortParams));
    state[masterMapName] = { ...state[masterMapName], ...byIdObj };
    var newsize = state[masterMapName][key].length;
    changed = prevsize != newsize ? "changed" : "not_changed";
  }
  return changed;
}

export function assembleRallyObject(childName, idFx, rallyObjs, respObj) {
  if (!rallyObjs) {
    rallyObjs = {};
  }
  if (respObj && respObj.data && respObj.data.data) {
    for (var r of respObj.data.data) {
      if (r.attributes) {
        var id = idFx(r);
        if (id) {
          var rallyObj = rallyObjs[id];
          if (!rallyObj) {
            rallyObj = { id };
          }
          rallyObj[childName] = r;
          rallyObjs[id] = rallyObj;
        }
      }
    }
  }
  return rallyObjs;
}

export function formatDate(selectedEvent) {
  var startDate = moment(selectedEvent.start)
    .tz(selectedEvent.timezone)
    .format("MM/DD/YYYY");
  var endDate = moment(selectedEvent.end)
    .tz(selectedEvent.timezone)
    .format("MM/DD/YYYY");
  var endFormat = "hh:mm a";
  if (startDate != endDate) {
    endFormat = "MM/DD/YYYY hh:mm a";
  }
  return (
    moment(selectedEvent.start)
      .tz(selectedEvent.timezone)
      .format("MM/DD/YYYY hh:mm a") +
    "-" +
    moment(selectedEvent.end)
      .tz(selectedEvent.timezone)
      .format(endFormat)
  );
}



export function formatDateEvent(selectedEvent, userTz) {
  let tz = getTimezone(selectedEvent, userTz)
  let allDay = (selectedEvent['all-day'] == 1 || selectedEvent['all_day'] == 1)

  if (allDay) {
    let s = moment(selectedEvent['start']).add(12, 'h').format("MM/DD/YYYY")
    let e = moment(selectedEvent['end']).subtract(12, 'h').format("MM/DD/YYYY")
    if (s== e || !e) {
      return s
    } else {
      return  s + " - " + e
    }
  } else {
      let startFormat =  "MM/DD/YYYY hh:mm a"
      let startDate = moment(selectedEvent['start_time']).tz(tz).format("MM/DD/YYYY");
      let endDate = moment(selectedEvent['end_time']).tz(tz).format("MM/DD/YYYY");

      var endFormat = "hh:mm a";
      if (startDate != endDate){
        endFormat = "MM/DD/YYYY hh:mm a";
      }
      return  moment(selectedEvent['start_time']).tz(tz).format(startFormat) + (!endFormat ? "" : "-" + moment(selectedEvent['end_time']).tz(tz).format(endFormat))
  }

}

export function formatDateSignup(selectedEvent, userTz) { 
  if (!selectedEvent['converted-start']){
    return formatDateSignupNoCovertedDate(selectedEvent, userTz)
  } else {
    let tz = getTimezone(selectedEvent, userTz)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")
    let startFormat = allDay ? "ddd MMM D, YYYY" : "ddd MMM D, YYYY hh:mm a"

    let startDate = moment.utc(selectedEvent['converted-start']).format("ddd MMM D, YYYY");
    let endDate = moment.utc(selectedEvent['converted-end']).format("ddd MMM D, YYYY");
    let endDateMinus1Day = moment.utc(selectedEvent['converted-end']).subtract(1, "days").format("YYYY/MM/DD");
    var endFormat = "hh:mm a";

    if (allDay && ((startDateArr[0]  != endDateArr[0]) && (startDateArr[0] != endDateMinus1Day))){
      return startDateArr[0] + " - " + endDateMinus1Day
    } else if (allDay) {
      return startDateArr[0]
    }else if (startDate != endDate) {
      endFormat = "ddd MMM D, YYYY hh:mm a";
    }
    return  moment.utc(selectedEvent['converted-start']).format(startFormat) +
        (!endFormat ? "" : " - " +
            moment.utc(selectedEvent['converted-end']).format(endFormat)) + ' ' +
        moment.tz(startDateArr[0], tz).format('z')
    
  }
}

export function formatDateNoTimezoneConversion(selectedEvent, userTz) {
  //if (!selectedEvent['converted-start']){
   /// return formatDateSignupNoCovertedDate(selectedEvent, userTz)
  //} else {
    let tz = getTimezone(selectedEvent, userTz)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")
    let endDateMinus1Day = moment(selectedEvent['converted-end']).subtract(1, "days").tz(tz).format("YYYY/MM/DD");
    if (allDay && ((startDateArr[0]  != endDateArr[0]) && (startDateArr[0] != endDateMinus1Day))){
      return startDateArr[0] + " - " + endDateMinus1Day
    } else if (allDay) {
      return startDateArr[0]
    } else if ((startDateArr[0] == endDateArr[0]) ||  (startDateArr[0] == endDateMinus1Day)) {
      return startDateArr[0] + " " + format24Hourto12HourTime(startDateArr[1]) + "-" + format24Hourto12HourTime(endDateArr[1])
    } else if (startDateArr[0] != endDateArr[0]) {
      return startDateArr[0] + "  " +  format24Hourto12HourTime(startDateArr[1]) + "-" + endDateArr[0] + " " + format24Hourto12HourTime(endDateArr[1])
    } else {
      return ""
    }
//}
    
}

export function formatDateOnlyNoTimezoneConversion(selectedEvent, userTz) {
    let tz = getTimezone(selectedEvent, userTz)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")
    let endDateMinus1Day = moment(selectedEvent['converted-end']).subtract(1, "days").tz(tz).format("YYYY/MM/DD");
    if (allDay && ((startDateArr[0]  != endDateArr[0]) && (startDateArr[0] != endDateMinus1Day))){
        return moment(startDateArr[0]).format('MMM D, YYYY') + " - " + moment(endDateMinus1Day).format('MMM D, YYYY')
    } else if (allDay) {
        return moment(startDateArr[0]).format('MMM D, YYYY')
    } else if ((startDateArr[0] == endDateArr[0]) ||  (startDateArr[0] == endDateMinus1Day)) {
        return moment(startDateArr[0]).format('MMM D, YYYY')
    } else if (startDateArr[0] != endDateArr[0]) {
        return moment(startDateArr[0]).format('MMM D, YYYY') + "-" + moment(endDateArr[0]).format('MMM D, YYYY')
    } else {
        return ""
    }
//}
}

export function formatDateTimeNoTimezoneConversion(selectedEvent, userTz) {
    let tz = getTimezone(selectedEvent, userTz)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")
    let endDateMinus1Day = moment(selectedEvent['converted-end']).subtract(1, "days").tz(tz).format("YYYY/MM/DD");

    if (allDay && ((startDateArr[0]  != endDateArr[0]) && (startDateArr[0] != endDateMinus1Day))){
        return moment(startDateArr[0]).format('ddd MMM D, YYYY') + ' ' + moment.utc(selectedEvent['converted-start']).format('h:mm A')
    } else if (allDay) {
        return moment(startDateArr[0]).format('ddd MMM D, YYYY')
    } else if ((startDateArr[0] == endDateArr[0]) ||  (startDateArr[0] == endDateMinus1Day)) {
        return moment(startDateArr[0]).format('ddd MMM D, YYYY') + ' ' + moment.utc(selectedEvent['converted-start']).format('h:mm A')
    } else if (startDateArr[0] != endDateArr[0]) {
        return moment(startDateArr[0]).format('ddd MMM D, YYYY') + ' ' + moment.utc(selectedEvent['converted-start']).format('h:mm A')
    } else {
        return ""
    }
//}
}

export function eventMonth(selectedEvent, userTz){
  let tz =  getTimezoneV2(selectedEvent, userTz)
  let needsTz = false 
  needsTz = checkNeedsTz(selectedEvent)
  let startDateArr =  selectedEvent['converted-start'].split(" ")
  return conditionalDateTimeTZ( selectedEvent['converted-start'],tz,needsTz).format("MMM").toUpperCase();
}

export function eventDay(selectedEvent, userTz){
  let tz =  getTimezoneV2(selectedEvent, userTz)
  let needsTz = false 
  needsTz = checkNeedsTz(selectedEvent)
  //console.log("needstz" + needsTz)
  //console.log("event day " + selectedEvent['converted-start'] )
  return conditionalDateTimeTZ( selectedEvent['converted-start'] ,tz,needsTz).format("DD").toUpperCase();
}
export function formatDateTimeTimezoneConversion(selectedEvent, userTz) {
  let tz =  getTimezoneV2(selectedEvent, userTz)
  let needsTz = false 
  needsTz = checkNeedsTz(selectedEvent)
  let allDay = selectedEvent['all-day'] == 1
  let endDate= conditionalDateTimeTZ(selectedEvent['converted-end'],tz, needsTz).format("YYYY/MM/DD")
  let startDate= conditionalDateTimeTZ(selectedEvent['converted-start'],tz, needsTz).format("YYYY/MM/DD")
  let dateFormat = conditionalDateTimeTZ(selectedEvent['converted-start'], tz, needsTz).format('ddd MMM D, YYYY')
  if (allDay){
    dateFormat = conditionalDateTimeTZ(selectedEvent['converted-start'], tz, false).format('ddd MMM D, YYYY')
  }
  let timeFormat =  conditionalDateTimeTZ(selectedEvent['converted-start'], tz, needsTz).format('h:mm A')
  if (allDay) {
      return dateFormat
  } else if ((startDate == endDate)) {
      return dateFormat + ' ' + timeFormat 
  }  else {
      return ""
  }
//}
}

/*export function formatTimeOnlyNoTimezoneConversion(selectedEvent, userTz) {
    let tz = getTimezone(selectedEvent, userTz)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")

    let endDateMinus1Day = moment(selectedEvent['converted-end']).subtract(1, "days").tz(tz).format("YYYY/MM/DD");
    if (allDay && ((startDateArr[0]  != endDateArr[0]) && (startDateArr[0] != endDateMinus1Day))){
        return moment.utc(selectedEvent['converted-start']).format('h:mm A') + " - " +
            moment.utc(endDateMinus1Day).format('h:mm A') + " " +
            moment.tz(startDateArr[0], tz).format('z')
    } else if (allDay) {
        return moment.utc(selectedEvent['converted-start']).format('h:mm A') + " " +
            moment.tz(startDateArr[0], tz).format('z')
    } else if ((startDateArr[0] == endDateArr[0]) ||  (startDateArr[0] == endDateMinus1Day)) {
        return moment.utc(selectedEvent['converted-start']).format('h:mm A') + " - " +
            moment.utc(selectedEvent['converted-end']).format('h:mm A') + " " +
            moment.tz(startDateArr[0], tz).format('z')
    } else if (startDateArr[0] != endDateArr[0]) {
        return moment.utc(selectedEvent['converted-start']).format('h:mm A') + " - " +
            moment.utc(selectedEvent['converted-end']).format('h:mm A') + " " +
            moment.tz(startDateArr[0], tz).format('z')
    } else {
        return ""
    }
//}
}*/
export function formatEventLine1(selectedEvent, userTz) {
    let tz =  getTimezoneV2(selectedEvent, userTz)
    let needsTz = false 
    needsTz = checkNeedsTz(selectedEvent)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")
  //  let endDateMinus1Day = moment.utc(selectedEvent['converted-end']).subtract(1, "days").tz(tz).format("YYYY/MM/DD");
    let formattedRange = ''
    if( allDay ) {
        // --- All Day Event
        // --- Line 1 is the First Day
        formattedRange = conditionalDateTimeTZ(selectedEvent['converted-start'], tz, needsTz).format('MMM D, YYYY')
        if (selectedEvent['all-day-end-date'] && new Date(selectedEvent['all-day-start-date']).getDate()
            !== new Date(selectedEvent['all-day-end-date']).getDate() - 1) {
            formattedRange = formattedRange + ' - '
        }
    } else {
        // --- Day with a time
        formattedRange = formattedRange + conditionalDateTimeTZ(selectedEvent['converted-start'],tz, needsTz).format('MMM D, YYYY')
        if ((startDateArr[0] != endDateArr[0])) {
            if (endDateArr) {
                formattedRange = formattedRange + ' ' + conditionalDateTimeTZ(selectedEvent['converted-start'],tz, needsTz).format('h:mm A') + ' - '
            }
        }
    }

    return formattedRange
}

export function getTimezone(selectedEvent, userTz)
{
  console.log("user time zone:::" + userTz)
  return userTz && userTz != "UTC" ? userTz : selectedEvent.timezone ? selectedEvent.timezone : moment().format('Z')
}

export function getTimezoneV2(selectedEvent, userTz)
{
  return userTz && userTz != "UTC" ? userTz : getEventTimezoneV2(selectedEvent) ? getEventTimezoneV2(selectedEvent) : moment().format('Z')
}

export function getEventTimezoneV2(selectedEvent){
  return railsTzToMomentTz(selectedEvent["event-timezone"] ? selectedEvent["event-timezone"] : selectedEvent.timezone)
}



export function conditionalDateTimeTZ(convertedDate, tz, needsTz){
  let cs = convertedDate
  if (cs.indexOf(":") < 0){
    cs = cs + " 13:00:00"
  }
  if (needsTz){
    //console.log("returning moment date")
    return moment.utc(cs).tz(tz)
  } else {
    //console.log("not converting time" + cs)
    //console.log( cs)
    return moment.tz(cs, "YYYY/MM/DD HH:mm:ss", tz);
  }
}

/*
export function conditionalTZ(convertedDate, tz, needsTz){
  if (needsTz){
    console.log("returning moment date")
    return moment.utc(convertedDate).tz(tz)
  } else {
    console.log("not converting time" + convertedDate)
    console.log( convertedDate)
    return moment(convertedDate).tz(tz, true)
  }
}*/

export function conditionalDateTZ(convertedDate, tz, needsTz){
  if (needsTz){
    console.log("returning moment date")
    return moment.utc(convertedDate).tz(tz)
  } else {
    console.log("not converting date date" )
    console.log( convertedDate)
    return moment(convertedDate,  "YYYY/MM/DD", tz)
  }
}
export function checkNeedsTz(selectedEvent){
  //console.log("event timezone: " + selectedEvent["converted-timezone"])
  //console.log("event start: " + selectedEvent["converted-start"])
  return (selectedEvent["converted-timezone"] && selectedEvent["converted-timezone"].indexOf("UTC") > -1)
}

export function formatEventLine2(selectedEvent, userTz) {
    let tz =  getTimezoneV2(selectedEvent, userTz)
    let needsTz = false 
    needsTz = checkNeedsTz(selectedEvent)
    //console.log("needs TZ....." + needsTz)
    //console.log("tz is..." + tz)
    let allDay = selectedEvent['all-day'] == 1
    let startDateArr =  selectedEvent['converted-start'].split(" ")
    let endDateArr =  selectedEvent['converted-end'].split(" ")
    let endDateMinus1Day = conditionalDateTimeTZ(selectedEvent['converted-end'], tz, needsTz).subtract(1, "days").format("YYYY/MM/DD");
    let formattedRange = '';
    if (allDay) {
        // --- All Day Event
        // --- Line 2 is the Last Day
        if (selectedEvent['all-day-end-date'] && new Date(selectedEvent['all-day-start-date']).getDate() !==
            new Date(selectedEvent['all-day-end-date']).getDate() -1) {
            //formattedRange = formattedRange + ' - '
            formattedRange = formattedRange + moment.utc(endDateMinus1Day).format('MMM D, YYYY')
        }
    } else {
        // --- Day with a time
        if ((startDateArr[0] == endDateArr[0])) {
            // --- Event only 1 day so just show time on line 2
            formattedRange = formattedRange + conditionalDateTimeTZ(selectedEvent['converted-start'], tz, needsTz).format('h:mm A')
            if (endDateArr) {
                formattedRange = formattedRange +  ' - '
                formattedRange = formattedRange + conditionalDateTimeTZ(selectedEvent['converted-end'], tz, needsTz).format('h:mm A')
                formattedRange = formattedRange + ' ' + conditionalDateTimeTZ(selectedEvent['converted-end'], tz, needsTz).format('z')
            }
        } else {
            // --- Event spans multiple days so put the first day with time on line 1
            if (endDateArr) {
                // --- Event spans multiple days so put the last day with time on line 2
                formattedRange = formattedRange + conditionalDateTimeTZ(selectedEvent['converted-end'], tz, needsTz).format('MMM D, YYYY')
                formattedRange = formattedRange + ' '
                formattedRange = formattedRange + conditionalDateTimeTZ(selectedEvent['converted-end'], tz, needsTz).format('h:mm A')
                formattedRange = formattedRange + ' ' + conditionalDateTimeTZ(selectedEvent['converted-end'], tz, needsTz).format('z')
            }
        }
    }
    return formattedRange
}

export function format24Hourto12HourTime(ts){
  let tarr = ts.split(":")
  let hour = parseInt(tarr[0])
  let ampm = "AM"
  if (hour > 12){
    ampm = "PM"
    hour = hour -12
  }
  if (hour == 12){
    ampm = "PM"
  }
  if (hour == 0){
    hour = 12
  }
  return hour + ":" +  tarr[1] + " " + ampm

}


export function formatDateSignupNoCovertedDate(selectedEvent, userTz) {
    if (!selectedEvent['from-date']){
      return ""
    }
    //let tz = userTz ? userTz : selectedEvent.timezone
    let allDay = selectedEvent['all-day'] == 1
    //let startFormat = allDay ? "MM/DD/YYYY" : "MM/DD/YYYY hh:mm a"
    let startDate = selectedEvent['from-date']
    let endDate =selectedEvent['to-date']

    if (allDay && startDate != endDate){
      return startDate + " - " + endDate
    } else if (allDay) {
      return startDate
    } else if (startDate != endDate) {
      return startDate + " " + selectedEvent['from-time'] + "-" + endDate + " " + selectedEvent['to-time'] 
    } else if (startDate == endDate){
      return startDate + " " + selectedEvent['from-time'] + "-" + selectedEvent['to-time'] 
    } else {
      return ""
    }
}



export function formatDateSpecialEvent(selectedEvent) {
  var startDate = moment(selectedEvent['start_time'])
    .tz(selectedEvent.timezone)
    .format("MM/DD/YYYY");
  var endDate = moment(selectedEvent['end_time'])
    .tz(selectedEvent.timezone)
    .format("MM/DD/YYYY");
  var endFormat = "hh:mm a";
  if (startDate != endDate) {
    endFormat = "MM/DD/YYYY hh:mm a";
  }
  return (
    moment(selectedEvent['start_time'])
      .tz(selectedEvent.timezone)
      .format("MM/DD/YYYY hh:mm a") +
    "-" +
    moment(selectedEvent['end_time'])
     .tz(selectedEvent.timezone)
      .format(endFormat)
  );
}

const monthmap = {"Jan": "01", "Feb": "02", "Mar":"03", "Apr":"04", "May":"05", "Jun":"06", "Jul":"07", "Aug":"08", "Sep":"09", "Oct":"10", "Nov":"11", "Dec":"12"}

//convert dates in this format Fri Aug 26 2022 00:00:00 GMT-0500 (Central Daylight Time) to a simple MM/DD/YYYY format without
//moment timezone issues
export function datePickerConverter(dtObj) {
  //console.log("dtObj")
  //console.log(dtObj)
  let dtarr = dtObj.toString().split(" ") 
  return monthmap[dtarr[1]] + "/" + dtarr[2] + "/" + dtarr[3]//eventData
}

export function formatCurrency(val) {
  return "$" + (parseInt(val) / 100).toFixed(2);
}

export function findOrganizerParticipation(partIds, partMap) {
  for (var id of partIds) {
    var partObj = partMap[id.id];
    if (partObj && partObj.attributes["participant-type"] == "organizer") {
      return partObj;
    }
  }
  return null;
}

export function totalParticipantCount(partIds, partMap, status) {
  var count = 0;
  for (var id of partIds) {
    var partObj = partMap[id.id];
    if (
      partObj &&
      partObj.attributes["quantity"] &&
      partObj.attributes["participation-status"] == status
    ) {
      count = count + parseInt(partObj.attributes["quantity"]);
    }
  }
  return count;
}

//"part_first_name_1632_0":"j1","part_last_name_1632_0":"t2","part_email_1632_0":"j1@t1.com","part_first_name_1632_1":"j2","part_last_name_1632_1":"t2","part_email_1632_1":"j2@t2.com","part_first_name_1632_2":"","part_last_name_1632_2":"","part_email_1632_2":"","part_first_name_1632_3":"","part_last_name_1632_3":"","part_email_1632_3":"","part_first_name_1632_4":"","part_last_name_1632_4":"","part_email_1632_4":"","part_first_name_1632_5":"","part_last_name_1632_5":"","part_email_1632_5":"","part_first_name_1632_6":"","part_last_name_1632_6":"","part_email_1632_6":"","part_first_name_1632_7":"","part_last_name_1632_7":"","part_email_1632_7":"","part_first_name_1632_8":"","part_last_name_1632_8":"","part_email_1632_8":"","part_first_name_1632_9":"","part_last_name_1632_9":"","part_email_1632_9":"","part_first_name_1632_10":"","part_last_name_1632_10":"","part_email_1632_10":"","part_first_name_1632_11":"","part_last_name_1632_11":"","part_email_1632_11":"","part_first_name_1632_12":"","part_last_name_1632_12":"","part_email_1632_12":"","part_first_name_1632_13":"","part_last_name_1632_13":"","part_email_1632_13":"","part_first_name_1632_14":"","part_last_name_1632_14":"","part_email_1632_14":"","part_first_name_1632_15":"","part_last_name_1632_15":"","part_email_1632_15":"","part_first_name_1632_16":"","part_last_name_1632_16":"","part_email_1632_16":"","part_first_name_1632_17":"","part_last_name_1632_17":"","part_email_1632_17":"","part_first_name_1632_18":"","part_last_name_1632_18":"","part_email_1632_18":"","part_first_name_1632_19":"","part_last_name_1632_19":"","part_email_1632_19":"","part_first_name_1650_0":"j12","part_last_name_1650_0":"t12","part_email_1650_0":"j12@t12.com","part_first_name_1650_1":"jarjar","part_last_name_1650_1":"binks","part_email_1650_1":"jarjarbinks@test.com","part_first_name_1650_2":"","part_last_name_1650_2":"","part_email_1650_2":"","part_first_name_1650_3":"","part_last_name_1650_3":"","part_email_1650_3":"","part_first_name_1650_4":"","part_last_name_1650_4":"","part_email_1650_4":"","part_first_name_1650_5":"","part_last_name_1650_5":"","part_email_1650_5":"","part_first_name_1650_6":"","part_last_name_1650_6":"","part_email_1650_6":"","part_first_name_1650_7":"","part_last_name_1650_7":"","part_email_1650_7":"","part_first_name_1650_8":"","part_last_name_1650_8":"","part_email_1650_8":"","part_first_name_1650_9":"","part_last_name_1650_9":"","part_email_1650_9":"","part_first_name_1650_10":"","part_last_name_1650_10":"","part_email_1650_10":"","part_first_name_1650_11":"","part_last_name_1650_11":"","part_email_1650_11":"","part_first_name_1650_12":"","part_last_name_1650_12":"","part_email_1650_12":"","part_first_name_1650_13":"","part_last_name_1650_13":"","part_email_1650_13":"","part_first_name_1650_14":"","part_last_name_1650_14":"","part_email_1650_14":"","part_first_name_1650_15":"","part_last_name_1650_15":"","part_email_1650_15":"","part_first_name_1650_16":"","part_last_name_1650_16":"","part_email_1650_16":"","part_first_name_1650_17":"","part_last_name_1650_17":"","part_email_1650_17":"","part_first_name_1650_18":"","part_last_name_1650_18":"","part_email_1650_18":"","part_first_name_1650_19":"","part_last_name_1650_19":"","part_email_1650_19":"","part_first_name_1713_0":"","part_last_name_1713_0":"","part_email_1713_0":"","part_first_name_1713_1":"","part_last_name_1713_1":"","part_email_1713_1":"","part_first_name_1713_2":"","part_last_name_1713_2":"","part_email_1713_2":"","part_first_name_1713_3":"","part_last_name_1713_3":"","part_email_1713_3":"","part_first_name_1713_4":"","part_last_name_1713_4":"","part_email_1713_4":"","part_first_name_1713_5":"","part_last_name_1713_5":"","part_email_1713_5":"","part_first_name_1713_6":"","part_last_name_1713_6":"","part_email_1713_6":"","part_first_name_1713_7":"","part_last_name_1713_7":"","part_email_1713_7":"","part_first_name_1713_8":"","part_last_name_1713_8":"","part_email_1713_8":"","part_first_name_1713_9":"","part_last_name_1713_9":"","part_email_1713_9":"","part_first_name_1713_10":"","part_last_name_1713_10":"","part_email_1713_10":"","part_first_name_1713_11":"","part_last_name_1713_11":"","part_email_1713_11":"","part_first_name_1713_12":"","part_last_name_1713_12":"","part_email_1713_12":"","part_first_name_1713_13":"","part_last_name_1713_13":"","part_email_1713_13":"","part_first_name_1713_14":"","part_last_name_1713_14":"","part_email_1713_14":"","part_first_name_1713_15":"","part_last_name_1713_15":"","part_email_1713_15":"","part_first_name_1713_16":"","part_last_name_1713_16":"","part_email_1713_16":"","part_first_name_1713_17":"","part_last_name_1713_17":"","part_email_1713_17":"","part_first_name_1713_18":"","part_last_name_1713_18":"","part_email_1713_18":"","part_first_name_1713_19":"","part_last_name_1713_19":"","part_email_1713_19":"","fundraiser_type":"PaidEvent"}"

export function buildParticipantJSON(pl) {
  if (!pl || pl.length == 0) {
    return null;
  }
  var obj = {};
  for (var p of pl) {
    obj["part_first_name_" + p.id] = p.firstName;
    obj["part_last_name_" + p.id] = p.lastName;
    obj["part_email_" + p.id] = p.email;
  }
  obj["fundraiser_type"] = "PaidEvent";
  return btoa(JSON.stringify(obj));
}

export function avaUrl(c) {
    if (c === undefined) {
        return ""
    }
    if (c.attributes === undefined) {
        return ""
    }
    var imgUrl =  window.innerWidth < 769 ? c.attributes["small-url"] : c.attributes["large-url"];
    if (imgUrl && imgUrl.indexOf("https://") < 0){
      return "https://" + imgUrl
    } else {
      return imgUrl
    }
}

export function imgUrl(c) {
  var imgUrl =  c.attributes["original-url"]
  if (imgUrl && imgUrl.indexOf("https://") < 0){
    return "https://" + imgUrl
  } else {
    return imgUrl
  }
}

export function originalImgUrl(c) {
    var imgUrl =  (typeof c === 'string') ? c : c.attributes["url"]
    if (imgUrl && imgUrl.indexOf("https://") < 0){
        return "https://" + imgUrl
    } else {
        return imgUrl
    }
}

export function mediumImgUrl(c) {
    var imgUrl =  c.attributes["medium-url"]
    if (imgUrl && imgUrl.indexOf("https://") < 0){
        return "https://" + imgUrl
    } else {
        return imgUrl
    }
}

export async function redirectToChannel(channels, rallyId, next) {
    const viewableChannel = channels.find(c => c.attributes && (c.attributes.viewable || c.attributes.writable));

    if (viewableChannel) {
        let path = `/${rallyId}/${viewableChannel.attributes.slug}`
        next({ path: `/${rallyId}/${viewableChannel.attributes.slug}` });
    } else {
        next(); // Render the default component if no channel meets the criteria
    }
}

export function chunkFile(file, chunkSize = 1 * 1024 * 1024) { // 1MB for testing
  const chunks = [];
  let start = 0;
  console.log("file.size" + file.size)
  while (start < file.size) {
    const end = Math.min(start + chunkSize, file.size);
    console.log("end" + end)
    chunks.push(file.slice(start, end));
    start = end;
  }
  console.log("chunks")
  console.log(chunks)
  return chunks;
}

export function getChannelSlug(route) {
    // Used in place of channel.type.
    console.log("getChannelSlug")
    console.log(route)

    if (route?.query?.fundraiser_type){
      //alert(route.params.channelSlug +  "?fundraiser_type=" + route?.query?.fundraiser_type)
      const s =   route.params.channelSlug +  "?fundraiser_type=" + route?.query?.fundraiser_type
      return s
    } else {
      return route.params.channelSlug
    }
}

export function isPasswordValid(password){
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/
    return passwordRegex.test(password);
}


// helper function
const convertBlobToBase64 = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  export function waitForElement(selector) {
    return new Promise(resolve => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);
  
      const observer = new MutationObserver((_, obs) => {
        const el = document.querySelector(selector);
        if (el) {
          obs.disconnect();
          resolve(el);
        }
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  export function getUrlContentPathElements(routePath){
    const segments = routePath.split('/').filter(Boolean)
    const index = segments.indexOf("c")
    const result = index !== -1 ? segments.slice(index + 1) : []
    return result
  };

  export function hasGrandParentContext(routePath){
    if (routePath.indexOf("/c/") > 0){
        const segments = getUrlContentPathElements(routePath)
        return  segments.length >= 1
    } 
    return false
  };

  export function grandParentContextId(routePath, channelId) {
    if (routePath && routePath.includes("/c/")) {
      const segments = getUrlContentPathElements(routePath)
      return segments.length >= 2 ? segments[segments.length - 2] : channelId;
    }
    return channelId;
  };
  
  export function grandParentContextType(routePath){
    if (routePath.indexOf("/c/") < 0){
      return "Channel"
     } else {
      const segments = getUrlContentPathElements(routePath)//routePath.split('/').filter(Boolean)
      if (segments.length >= 2){
         return "Container"
      } else {
        return "Channel"
      }
      
    }
  };

  const ONE_MB = 1024 * 1024;

  export function messageWallBodyTooLarge(str) {
    const bytes = new TextEncoder().encode(str).length;
    return bytes > ONE_MB;
  }

export function getByteSize(value) {
  if (value instanceof Blob) {
    return value.size;
  }

  if (typeof value === "string") {
    return new TextEncoder().encode(value).length;
  }

  // assume object
  return new TextEncoder().encode(JSON.stringify(value)).length;
}

export function formatSizeInMB(value, decimals = 2) {
  const bytes = getByteSize(value);
  const mb = bytes / ONE_MB;
  return `${mb.toFixed(decimals)} MB`;
}

  

  export const ACCEPTED_FILE_TYPES = "image/*, .ppt, .pptx, .pdf, .doc, .docx, .xml, .xls, .xlsx, .csv, .txt, .rtf, .mov, .mp4, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document";

